import { stringify } from 'qs';

export const generateShopifyAuthorizationUrl = (storeUrl, scopes = undefined) => {

    if ( !(/^[a-zA-Z0-9][a-zA-Z0-9\-]*\.myshopify\.com$/.test(storeUrl)) ) {
        return false;
    }

    const shopifyScopes = scopes || [
        'read_all_orders',
        'read_orders',
        // 'read_reports',
        // 'write_reports',
    ]

    let state = Math.random().toString();
    window.localStorage.setItem('shopifyState', state);

    const params = {
        client_id: process.env.SHOPIFY_APP_ID,
        scope: shopifyScopes.join(','),
        redirect_uri: window.location.origin + '/shopify-callback',
        state,
    }

    return (
        'https://' +
        storeUrl +
        '/admin/oauth/authorize?' +
        stringify(params)
    )

}